import { getContext } from "./getContext";
import { makeProposal } from "./makeProposal";

export const salvcarService = {
  getContext,
  makeProposal,
};
